<h2 mat-dialog-title>Route</h2>

<form #apiKeyForm="ngForm" fxLayout="column" fxFill fxLayoutGap fxLayoutAlign="center center" *ngIf="locationRoute">
  <mat-dialog-content fxFill>
    <mat-slide-toggle fxFill name="enabled" [checked]="locationRoute.enabled"
      [(ngModel)]="locationRoute.enabled" [disabled]="!isEnabled('enabled')">
      Enabled
      <mat-hint> - unchecking will disable the Route</mat-hint>
    </mat-slide-toggle>

    <mat-form-field fxFill>
      <mat-label>Scheme</mat-label>
      <input matInput [disabled]="!isEnabled('scheme')" placeholder="Scheme" name="scheme" [(ngModel)]="locationRoute.scheme" [matAutocomplete]="schemeAutocomplete">
    </mat-form-field>
    <mat-autocomplete #schemeAutocomplete="matAutocomplete">
      <mat-option *ngFor="let scheme of knownRoutes" [value]="scheme">
        {{ scheme }}
      </mat-option>
    </mat-autocomplete>

    <mat-form-field fxFill>
      <mat-label>Gateway</mat-label>
      <mat-select [disabled]="!isEnabled('gatewayName')" name="gatewayName" [(ngModel)]="locationRoute.gatewayName">
        <mat-option *ngFor="let gateway of gateways" [value]="gateway">
          {{gateway}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFill>
      <mat-label>Merchant ID</mat-label>
      <input matInput [disabled]="!isEnabled('merchantId')" placeholder="Merchant ID" name="merchantId" [(ngModel)]="locationRoute.merchantId">
    </mat-form-field>

    <mat-form-field fxFill>
      <mat-label>Processor Instance</mat-label>
      <input matInput [disabled]="!isEnabled('processorInstance')" placeholder="MARSGCPLondon" name="processorInstance" [(ngModel)]="locationRoute.processorInstance">
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions fxLayoutAlign="end">
      <button mat-raised-button (click)="close()">Close</button>
      <button color="primary" mat-raised-button (click)="save()" *ngIf="isEnabled('save')" [disabled]="!apiKeyForm.valid || !apiKeyForm.dirty">Save</button>
  </mat-dialog-actions>
</form>
